export default __webpack_public_path__ + "static/media/nginx.5debeb43.svg";